import React from 'react'
import Gallery from '../components/Gallery'
import _ from 'underscore';
import styles from '../styles/university.module.css';
import { Grid, Icon, Search, Container, Segment, Header, Divider, Image, Input, Pagination } from 'semantic-ui-react'
import course from './assets/course.jpg'
import { uniThumbnailPath, slash, toSlug } from '../utils/utils'
import Helmet from 'react-helmet'
import uniImage from './assets/university.jpg'

const imagePath = "/icons/";


export default class University extends React.Component  {

  state = { activePage: 1, searchKey: '' }

  handleInputChange = (e, { value }) => {
    this.setState({ searchKey: value });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
  }

  handleInputRemove = (e) => {
    const { searchKey } = this.state;
    if(searchKey !== '') {
      this.setState({ searchKey: ''});
    }
  }

  render() {

    const { activePage, searchKey } = this.state
    const icon = searchKey !== '' ? 'remove' : 'search';
    const showableUniversity = (university, hideUniversity)  => {
      return university.filter(({node}) => {
        return ! hideUniversity.includes(node.uslug);
      });
    }

    const university = this.props.data.allUniversity.edges;
    const hideUniversity = this.props.data.allHideUniversity.edges[0].node.university;

    const pageTitle = "CHOOSE RIGHT UNIVERSITY TO DEVELOP YOUR FUTURE | Uni Village Education";
    const description = "We provide more than 60 university information. Find your right university right now!";

    let allData = showableUniversity(university, hideUniversity).map(({node}) => {
        return {
          image: node.photo,
          title: node.university,
          path: slash(node.uslug)
        }
      return {};
    });
    allData = _.uniq(allData, _.property('path'));

    const itemPerPage = 10;
    const totalPages = Math.floor(allData.length / itemPerPage);
    const from = (activePage - 1) * itemPerPage;
    const to = activePage * itemPerPage;

    const data = allData.slice(from , to)
      .filter(({ title }) => {
        const key = searchKey.toLowerCase();
        return title.toLowerCase().indexOf(key) !== -1;
    });

    return (
      <Container textAlign='center'>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={description} />
      </Helmet>
      {allData.map(({path, title}) => {
        return <a style={{display:'none'}} href={path}>{title}</a>
      })}

      <Header as='h3' icon>
        <Image src={course} />
        UNIVERSITY DIRECTORY
        <Header.Subheader>Your Passort To Excellent Education</Header.Subheader>
      </Header>
      <Image src={uniImage} fluid />
      <Divider hidden />
      <Input size='small' icon={icon} value={searchKey} placeholder='Search university or scholarship name'
        fluid onChange={this.handleInputChange}
        onClick={this.handleInputRemove} />
      { searchKey === '' && <Header size='small' textAlign='left'>{from +1 } of {allData.length} results</Header>}
      { searchKey !== '' && <Header size='small' textAlign='left'>{data.length} results</Header>}
      <Divider hidden />
      <Gallery data={data} />
      <Divider hidden />
      { searchKey === '' && <Pagination firstItem={null} lastItem={null} activePage={activePage}
        onPageChange={this.handlePaginationChange} totalPages={totalPages} /> }
      <Divider hidden />
      </Container>
    )
  }
}

export const pageQuery = graphql`
  query CoverImageQuery {
  	allUniversity: allUniversityJson {
      totalCount
      edges {
        node {
          university
          uslug
          photo
        }
      }
    }

    allHideUniversity: allBlacklistJson {
      edges {
        node {
          university
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/universities.js